import React, { Component } from "react";
import GravityForm from "react-gravity-form";
import GoogleMap, {Marker} from '../global/GoogleMap';

export default class PageContact extends Component {
	
	render () {
		
		let block = this.props.block;
				
		if (block) {
												
		    return (
			    			    
			    <div data-id={block.id} className="c-page__block c-page__block--space-small c-page__block--load-effect">
			    
			    	<div className="l-content l-content--fixed-width c-page__block--space-small">
			    		
			    		<div className="l-grid">
			    		
			    			<div className="l-grid__col">
			    				
								<h1 className="c-paragraph c-paragraph--xxxlarge" dangerouslySetInnerHTML={{__html:block.heading}}></h1>
								
							</div>
							
						</div>
			    		
			    	</div>
			    
			    	<div className="l-content l-content--fixed-width">
			    		
			    		<div className="l-grid">
			    						    				
							{block.locations.map((location,i) =>
								{
									return (
									
										<div className="l-grid__col l-grid__col--m-6-12 c-page__block--space-small" key={i}>
										
											<div className="c-location">
											
												<div className="c-location__map">
													
													<div className="c-location__map__inner">
													
														<GoogleMap latitude={location.latitude} longitude={location.longitude} zoom={parseInt(location.zoom)}></GoogleMap>
													
													</div>
												
												</div>
												
												<div className="c-location__text">
													
													<div className="c-location__text__left">
														
														{location.heading && 
															<h1 className="c-paragraph" dangerouslySetInnerHTML={{__html:location.heading}}></h1>
														}
														{location.coordinates && 
															<p className="c-paragraph c-paragraph--faded c-paragraph--space" dangerouslySetInnerHTML={{__html:location.coordinates}}></p>
														}
														{location.text && 
															<p className="c-paragraph c-paragraph--faded c-paragraph--space" dangerouslySetInnerHTML={{__html:location.text}}></p>
														}
													
													</div>
													
													<div className="c-location__text__right">
														
														{location.phone && location.phone_url &&
															<p className="c-paragraph c-paragraph--faded" dangerouslySetInnerHTML={{__html:'Call: <a href="' + location.phone_url + '">' + location.phone + '</a>'}}></p>
														}
														{location.email && 
															<p className="c-paragraph c-paragraph--faded c-paragraph--space" dangerouslySetInnerHTML={{__html:'<a href="' + location.email + '">' + location.email + '</a>'}}></p>
														}
														{location.directions && 
															<p className="c-paragraph c-paragraph--space" dangerouslySetInnerHTML={{__html:'<a href="' + location.directions + '" target="_blank">Get directions</a>'}}></p>
														}
													
													</div>
												
												</div>
											
											</div>
											
										</div>
										
									)
								}
							)}	
							
						</div>
						
					</div>
					
					<div className="l-content">
			    		
			    		<div className="l-grid">
			    		
							<div className="l-grid__col l-grid__col--m-6-12">
							
								<div className="c-page__block--space-small">
								
									<h3 className="c-paragraph c-paragraph--xlarge" dangerouslySetInnerHTML={{__html:'Social'}}></h3>
									
								</div>
								
								<ul className="c-paragraph c-paragraph--faded">
									{block.instagram &&
										<li>
											<a href={block.instagram} target="_blank">Instagram</a>
										</li>
									}
									{block.linkedin &&
										<li>
											<a href={block.linkedin} target="_blank">LinkedIn</a>
										</li>
									}
									{block.facebook &&
										<li>
											<a href={block.instagram} target="_blank">Facebook</a>
										</li>
									}
								</ul>
								<div className="c-page__block--space-small"></div>
							</div>
							
							<div className="l-grid__col l-grid__col--m-6-12">
							
								{block.form_id &&
									
									<>
							
										{block.form_heading &&
										
											<div className="c-page__block--space-small">
											
												<h3 className="c-paragraph c-paragraph--xlarge" dangerouslySetInnerHTML={{__html:block.form_heading}}></h3>
												
											</div>
										
										}
										
										<div className="c-page__block--space-small scope-form">
											<GravityForm
												backendUrl={document.location.origin + '/wp-json/castran/v1/form'}
												formID={block.form_id}
											/>
										</div>
										
									</>
								
								}
							
							</div>
																
						</div>
			    		
			    	</div>
			    
			    </div>
			    
			)
			
		} else {
			
			return null;
		
		}
	}
}
